<template>
    <div class="modal-container modal-dialog-full-width">
        <div class="modal-header">
            <h4 class="modal-title">{{ filterTitle }}</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body modal-content-full-width">
            <div>
                <div v-for="(status, i) in statuses" :key="i" class="member-item" @click.stop="handleSelect(status)">
                    <span>{{ status }}</span>
                    <span class="check-mark" v-if="status === selectedStatus">
                        <md-icon>check_circle</md-icon>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusModal',
    props: {
        selectedStatus: {
            type: String,
            default: ''
        },
        filterTitle: {
            type: String,
            default: 'Stop Status'
        },
        statuses: {
            type: Array,
            default: () => []
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        handleSelect(status) {
            this.resolve(status);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-container {
    max-width: 500px;
}
</style>
